export const selectUpdateOptinsStatus = state => {
  return state.optins.updateOptinsStatus;
};
export const selectOptinsStatus = state => {
  return state.optins.optinsStatus;
};